import { defineEvent } from '../types/event';
export var COUPON_MODAL_SMS_STEP_VIEW = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        }
    ]
});
